import { attachmentClient } from '../services/attachment-client'

export const createNewAttachment = async (data) => {
  const response = await attachmentClient().post(`${process.env.REACT_APP_ATTACHMENTS_URL}`, data);
  return response.data;
}
